export default class ArgCaller
{
	type = "";
	caller = null;
	
	/**
	 * 用来标识新打开画面的源 包括记录，控件
	 * 1.若是通过menuItemButton打开 则此值为button的控件名称 当源画面切换记录的时候 若新画面有关联 则触发默认的关联查询 当源画面某个
	 * 无数据源控件的值发生变化的时候 因为button的控件名称与无数据源控件肯定不同 故不会触发新画面的linkVar方法
	 * 2.若是通过OpenForm命令打开 则此值由二次开发方法指定 callereditor可以控制linVar方法与画面再次打开的策略 callereditor从记录级控制画面打开策略
	 * */
	callerKey = "";
	joinGroup = null;
	joinAlias = "";
	
	enterMainForm = false;
	mainTableWhereValues = [];
	parameters = "";
	paramObject = null;
	authorityObject = null;
}



// WEBPACK FOOTER //
// ./src/formItem/ArgCaller.js